import React from 'react';
import { Box } from '@chakra-ui/react';
import SaktiSyncPanel from '../../sakti/components/SaktiSyncPanel';
import { useSaktiSync } from '../../sakti/hooks/useSaktiSync';
import MasterSyncApiService from '../services/masterSyncApiService';

const describeSuccess = (): string => 'Semua entitas selesai disinkronkan dari Odoo.';

const MasterSyncManagement: React.FC = () => {
  const sync = useSaktiSync(MasterSyncApiService, describeSuccess);

  return (
    <Box p={6}>
      <SaktiSyncPanel
        subtitle="Jalankan script sinkronisasi Odoo (estate structure, karyawan, foreman group)"
        entities={sync.entities}
        loadingEntities={sync.loadingEntities}
        entitiesError={sync.entitiesError}
        selected={sync.selected}
        job={sync.job}
        isSyncing={sync.isSyncing}
        onToggleEntity={sync.toggleEntity}
        onSelectAll={sync.selectAllEntities}
        onClearSelection={sync.clearSelection}
        onSyncAll={sync.syncAll}
        onSyncSelected={sync.syncSelected}
        onReloadEntities={sync.reloadEntities}
      />
    </Box>
  );
};

export default MasterSyncManagement;
